export enum AutomixMicOptimizationMode {
	Normal = 'NORMAL',
	Mxa910 = 'MXA910',
	Mxa310 = 'MXA310',
	Mxa710 = 'MXA710',
	Mxa901 = 'MXA901',
	Mxa902 = 'MXA902',
	Mxa920 = 'MXA920'
}
